// MEMO: group이라는 테이블을 만들어서 관리되어야 할 것 같습니다.
export const GROUP_TYPE = {
  MARPPLE_CORPORATION: 'MARPPLE_CORPORATION',
  MARPPLE_INHOUSE_MALL_NBOX: 'MARPPLE_INHOUSE_MALL_NBOX',
  NEXON_ESSENTIAL: 'NEXON_ESSENTIAL',
  SOOP: 'SOOP',
};

export const GROUP_TYPE_NAME = {
  MARPPLE_CORPORATION: '마플/마플샵',
  MARPPLE_INHOUSE_MALL_NBOX: 'NBOX',
  NEXON_ESSENTIAL: '넥슨에센셜',
  SOOP: 'SOOP',
};
